<template>
  <div class="Tabs">
      <b-tabs v-model="tabIndex">
        <b-tab :title="lang.tab_SearchedParts" :title-link-class="textColors" :title-item-class="textColors" active >
            <SearchedPartsTableComponent :lang="lang.SearchedParts"></SearchedPartsTableComponent>
            
        </b-tab>
        <b-tab :title="lang.tab_CreatedByUser" :title-link-class="textColors" :title-item-class="textColors" >
              <PhysicalHandmadePartsTableComponent :lang="lang.CreatedByUser"></PhysicalHandmadePartsTableComponent>
            </b-tab>
        <b-tab :title="lang.tab_UsedMPNs" :title-link-class="textColors" :title-item-class="textColors" >
            <UsedMPNsTableComponent :lang="lang.UsedMPNs"></UsedMPNsTableComponent>
          </b-tab>

      </b-tabs>



  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import SearchedPartsTableComponent from "@/components/shared/SearchedPartsTableComponent"
import UsedMPNsTableComponent from "@/components/shared/UsedMPNsTableComponent"
import PhysicalHandmadePartsTableComponent from "@/components/shared/PhysicalHandmadePartsTableComponent"


export default {
  name: "Content",
  components: {
    SearchedPartsTableComponent,
    UsedMPNsTableComponent,
    PhysicalHandmadePartsTableComponent


  },
  props:{
    routingData: Object,
    lang: Object
  },
  data () {
    return {
      data: {},
      emptyHeight: "250px",
      dataCombobox: {title: "Filter list"},
      id: 1,
      isData: false,
      tabIndex: 0
    }
  },
  computed: {
    ...mapGetters({

      dataTable: 'dataTableSearched',

    }),
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    }
  },
  created () {
    

     if (Object.keys(this.$route.query).length != 0){

      var value = {searchString: this.$store.getters.searchingObject.searchString, providers: this.$store.getters.searchingObject.providers}

      

      this.$store.dispatch(this.$store.getters.sectionPrefix+'_getSearchedParts', value);
     }else{

      var value = {searchString: this.$store.getters.searchingObject.searchString, providers: this.$store.getters.searchingObject.providers}



      this.$store.dispatch(this.$store.getters.sectionPrefix+'_getSearchedParts', value);

       this.isData = true;
       this.data = this.dataTable
     }




  },
  updated() {
        

  },

  watch: {
    dataTable: function (newVal) {
            
            //console.log(newVal[this.filter.filterId].temp)

            if (newVal['columns'].length > 0){

              this.data = Object.assign({}, this.data, newVal)
              this.isData = true;
            }
            //store.dispatch('handleMyStateChange');
    },
    tabIndex: function (newVal) {

      
      this.$parent.$parent.$parent.switchButtons(newVal);
    },

  }
}
</script>

<style scooped>



  .bv-example-row-max{
    max-width: 100%;
    padding-right: 0px;
    padding-left: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/PartSearch/Middle/Content/Content.vue